// it could be your App.tsx file or theme file that is included in your tsconfig.json
// import { StyledEngineProvider } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material/styles';
import { createBrowserHistory } from 'history';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import { Router } from 'react-router-dom';
import ScrollReset from './components/ScrollReset';
import useSettings from './hooks/useSettings';
import Routes from './Routes';
import { createTheme } from './theme';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { makeStyles } from 'tss-react/mui';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { TssCacheProvider } from 'tss-react';

const history = createBrowserHistory();

const useStyles = makeStyles()((theme: any) => ({
	root: {
		fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
		fontWeight: 400,
		fontSize: '0.875rem',
		lineHeight: 1.43,
		letterSpacing: '0.01071em',
	},
}));

const muiCache = createCache({
	key: 'mui',
	prepend: true,
});

const tssCache = createCache({
	key: 'tss',
});

function App() {
	const { settings } = useSettings();
	const { classes } = useStyles();

	return (
		<CacheProvider value={muiCache}>
			<TssCacheProvider value={tssCache}>
				<ThemeProvider theme={createTheme(settings)}>
					{/* <StyledEngineProvider injectFirst> */}
					<LocalizationProvider dateAdapter={AdapterMoment}>
						<SnackbarProvider maxSnack={1} className={classes.root}>
							<Router history={history}>
								<ScrollReset />
								<Routes />
							</Router>
						</SnackbarProvider>
					</LocalizationProvider>
					{/* </StyledEngineProvider> */}
				</ThemeProvider>
			</TssCacheProvider>
		</CacheProvider>
	);
}

export default App;
